import {inject} from '@angular/core';
import {CategoryService} from '../category.service';
import {RenderStrategy} from '../../enums/render-strategy';
import {PointOfInterestService} from '../point-of-interest.service';
import {StoryService} from '../story.service';
import {RouteService} from '../route.service';

export const mapComponentResolver = () => {
  return Promise.all([
    inject(StoryService).resolveIndex(RenderStrategy.BROWSER),
    inject(CategoryService).resolveIndex(RenderStrategy.BROWSER),
    inject(PointOfInterestService).resolveIndex(RenderStrategy.BROWSER),
    inject(RouteService).resolveIndex(RenderStrategy.BROWSER),
  ]);
};
